import script from "./SocialFundCallPeriodDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundCallPeriodDialog.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundCallPeriodDialog.vue?vue&type=style&index=0&id=1631b3c3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1631b3c3"]])

export default __exports__